import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {ProductCardDialogData} from "./types/product-card.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {productCardModalName, productCardResourceType} from "./configs/product-card-configs";
import {ProductCardMarketplaceStateService} from "./services/product-card-marketplace-state.service";
import {Router} from "@angular/router";
import {NewProductCardComponent} from "./components/new-product-card/new-product-card.component";

@Component({
  selector: 'app-product-card-modal',
  imports: [
    BaseModalComponent,
    NewProductCardComponent
  ],
  standalone: true,
  templateUrl: './product-card-modal.component.html',
  styleUrl: './product-card-modal.component.scss'
})
export class ProductCardModalComponent extends BaseModalComponent {
  public productCardDialogData = inject<ProductCardDialogData>(MAT_DIALOG_DATA);
  private productCardMarketplaceStateService: ProductCardMarketplaceStateService = inject(ProductCardMarketplaceStateService);
  private router: Router = inject(Router);

  public readonly productCardResourceType = productCardResourceType;

  public override ngOnInit() {
    super.ngOnInit();
    this.modalStatesService.openModal(productCardModalName);
    this.productCardMarketplaceStateService.setProductCardMarketplaceState(this.productCardDialogData.parentPath);
  }

  public override ngOnDestroy() {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(productCardModalName);
    this.productCardMarketplaceStateService.resetProductCardMarketplaceState();
  }

  public updateProductCardInTable(id: number | null): void {
    id && this.openProductCardPage(id);
    this.closeDialog('cancel');
  }

  private openProductCardPage(productCardId: number): void {
    const urlTree = this.router.createUrlTree(['/records/product-card', productCardId]);
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }
}
